/* eslint-disable */
import api from '@/services/api';
import mime from 'mime-types';
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';

export default {
  async baixarDocumentos(_, payload) {
    try {
      const params = new URLSearchParams();

      if (payload?.documentos?.length) {
        payload.documentos.forEach(({ hash }) => {
          params.append('hash', hash);
        });
      } else {
        params.append('hash', payload.hash);
      }

      params.append('cnpj', payload.cnpj);

      const response = await api.get('/processoArquivos/arquivos/baixar', { params, responseType: 'arraybuffer' });

      const nomeArquivo = response.headers['content-disposition'].split('\"')[1];

      const blob = new Blob([response.data]);

      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = nomeArquivo;

      link.click();

      Vue.$toast.success(
        Vuetify.framework.lang.t('$vuetify.documentoBaixadoSucesso')
      );
    } catch(e) {
      Vue.$toast.clear();
      Vue.$toast.error(
        Vuetify.framework.lang.t('$vuetify.erroBaixarDocumento')
    )}
  },
  async baixarDocumentosOracleS3(_, payload) {
    try {
      const params = new URLSearchParams();

      if (payload.documentos?.length) {
        payload.documentos.forEach((doc) => {
          if (doc.isAws) {
            // Se for um documento da AWS, adiciona o caminhoS3
            params.append('caminhosS3', doc.caminhoS3);
          } else if (doc.hash) {
            // Caso contrário, adiciona o hash
            params.append('hash', doc.hash);
          }
        });
      } else if (payload.hash) {
        // Caso só tenha um hash simples no payload
        params.append('hash', payload.hash);
      }

      params.append('cnpj', payload.cnpj);

      const response = await api.get('/processoArquivos/arquivos-oracle-s3/baixar', { params, responseType: 'arraybuffer' });

      const nomeArquivo = response.headers['content-disposition'].split('\"')[1];

      const blob = new Blob([response.data]);

      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = nomeArquivo;

      link.click();

      Vue.$toast.success(
        Vuetify.framework.lang.t('$vuetify.documentoBaixadoSucesso')
      );
    } catch(e) {
      Vue.$toast.clear();
      Vue.$toast.error(
        Vuetify.framework.lang.t('$vuetify.erroBaixarDocumento')
    )}
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async visualizarDocumento(_, payload) {
    try {
      const params = new URLSearchParams();

      params.append('hash', payload.hash);
      params.append('cnpj', payload.cnpj);

      const response = await api.get('/processoArquivos/arquivos/baixar', { params, responseType: 'arraybuffer' });

      // transformar nome do arquivo e pegar somente a extensão para obter o mimetype
      // com o mimetype correto, ele consegue criar o objeto e visualizar corretamente
      const nomeArquivo = response.headers['content-disposition'].split('\"')[1];
      const extensaoArquivo = nomeArquivo.match(/\.([^.]+)$/)[1];

      const type = mime.lookup(extensaoArquivo);

      const blob = new Blob([response.data], { type });

      const url = window.URL.createObjectURL(blob);

      window.open(url);
      window.URL.revokeObjectURL(url);
    } catch(e) {
      Vue.$toast.clear();
      Vue.$toast.error(
        Vuetify.framework.lang.t('$vuetify.erroVisualizarDocumento')
    )}
  },
  async filtrarDocumentosOriginais({ commit }, payload) {
    commit('SET_DOCUMENTOS_ORIGINAIS_FILTROS', payload);
  },
  async fetchDocumentosOriginaisItens({ commit, rootGetters }) {
    const filtros = rootGetters['ged/getDocumentosOriginaisFiltros'];

    const params = new URLSearchParams();

    Object.keys(filtros).forEach((key) => {
      const value = filtros[key];
      if (Array.isArray(value)) {
        params.append(key, value.join(','));
      } else if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
        });
      } else if (value) {
        params.append(key, value);
      }
    });

    await api.get('/documentos-originais', { params })
      .then(data => {
        commit('SET_DOCUMENTOS_ORIGINAIS_ITENS', data.data.data);
        commit('paginacao/SET_PAGINADOR', data.data, { root: true });
      })
      .catch((err) => {
        throw err;
      });
  }
};
